import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { PortalThemeTemplate } from '@nx-frontend/shared/types';

export async function getPortalThemes(): Promise<PortalThemeTemplate> {
  try {
    const response = await axiosClient.get<PortalThemeTemplate>(`${generalEnv.nextApiPath}/portal-themes`);
    return response.data;
  } catch (error) {
    console.error('Error fetching portal themes:', error);
    throw error;
  }
}
